"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/**
 * A hook that returns true after a certain amount of time has passed
 */
const useDelay = (ms) => {
    const [done, setDone] = react_1.useState(false);
    react_1.useEffect(() => {
        const tId = setTimeout(() => setDone(true), ms);
        return () => clearTimeout(tId);
    }, []);
    return done;
};
exports.default = useDelay;
